import { handleUseTranslation } from 'config/i18n';
import {
  handleCreateNotionPage,
  handleValidateFields,
  handleValidateRate,
} from './submit-contact-form';

export const handleSubmitContactForm = async (
  formData: FormData,
  { locale }: { locale: string },
) => {
  const { t } = await handleUseTranslation(locale);

  const [validationError, validationResult] = await handleValidateFields(
    formData,
    locale,
  );

  if (validationError) {
    return validationError;
  }

  const [rateError] = await handleValidateRate(locale);

  if (rateError) {
    return rateError;
  }

  const [notionError] = await handleCreateNotionPage(
    (validationResult as any)?.data,
    locale,
  );

  if (notionError) {
    return notionError;
  }

  return {
    status: 'success',
    message: {
      title: t('data.email.success.title'),
      description: t('data.email.success.description'),
    },
    errors: undefined,
  };
};
